import type { Dispatch, SetStateAction } from 'react';

export function useRowSelection(id: string, selectedRowsState?: [string[], Dispatch<SetStateAction<string[]>>]) {
  const isSelected = selectedRowsState?.[0].includes(id);

  const onSelectRow = () => {
    if (!selectedRowsState) return;
    selectedRowsState[1](isSelected ? selectedRowsState[0].filter((x) => x !== id) : [...selectedRowsState[0], id]);
  };

  return {
    isSelected,
    onSelectRow,
  };
}
